<div
  class="vw-footer"
  *ngIf="layerOne.length || layerTwo.length || layerThree.length"
>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12 col-md-6 offset-md-1" *ngIf="layerOne.length">
        <div class="row">
          <div class="col-12">
            <h4 class="bold">{{ "footer.layer1" | translate }}</h4>
          </div>

          <div
            *ngFor="let link of layerOne; let i = index"
            [class.col-md-6]="i % 2 === 0"
            [class.col-12]="i % 2 === 0"
            [class.col-12]="i % 2 !== 0"
            [class.col-md-3]="i % 2 !== 0"
            [class.offset-md-3]="i % 2 !== 0"
          >
            <vw-link
              *ngIf="!isArray(link.url)"
              [text]="link?.displayName"
              [href]="link.url"
              [regularLink]="true"
            ></vw-link>
            <vw-link
              *ngIf="isArray(link.url)"
              [routerLinks]="link.url"
              [text]="link?.displayName"
            ></vw-link>
          </div>
        </div>
      </div>

      <div class="col-12 col-md-2 offset-md-2" *ngIf="layerTwo.length">
        <div class="row mt-4 mt-md-0">
          <div class="col-12">
            <h4 class="bold">{{ "footer.layer2" | translate }}</h4>
          </div>
          <div class="col-12" *ngFor="let link of layerTwo">
            <vw-link
              *ngIf="!isArray(link.url)"
              [text]="link?.displayName"
              [href]="link.url"
              [regularLink]="true"
            ></vw-link>
            <vw-link
              *ngIf="isArray(link.url)"
              [routerLinks]="link.url"
              [text]="link?.displayName"
            ></vw-link>
          </div>
        </div>
      </div>
    </div>

    <div
      class="row"
      *ngIf="
        (layerThree && layerThree.length) ||
        (modelAndDealerService.selectedDealer &&
          modelAndDealerService.selectedDealer.organisationNumber)
      "
    >
      <div class="col-md-11 offset-md-1">
        <div class="additional mt-5">
          <ul>
            <li *ngFor="let link of layerThree">
              <vw-link
                *ngIf="!isArray(link.url)"
                [text]="link?.displayName"
                [href]="link.url"
                [regularLink]="true"
              ></vw-link>
              <vw-link
                *ngIf="isArray(link.url)"
                [routerLinks]="link.url"
                [text]="link?.displayName"
              ></vw-link>
            </li>
            <li
              *ngIf="
                modelAndDealerService.selectedDealer &&
                modelAndDealerService.selectedDealer.organisationNumber
              "
            >
              <span class="fw-normal">{{
                "footer.dealerOrgNr"
                  | translate
                    : {
                        orgNr:
                          modelAndDealerService.selectedDealer
                            .organisationNumber,
                      }
              }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
